import React from "react";
import { Card, Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export type Device = {
  name: string;
  description: string;
};

export interface User {
  id: number;
  name: string;
  surname: string;
  avatar: string | null;
  position: string;
  assignedTo?: {
    id: number;
    name: string;
    surname: string;
  } | null;
  currentDevices: Device[]; // Zmiana: lista urządzeń przypisanych do użytkownika
}

type UserCardProps = {
  data: User;
};

const UserCard = ({ data }: UserCardProps) => {
  const navigate = useNavigate();

  return (
    <Card className="p-3 mb-2">
      <Row className="align-items-start">
        <Col xs={12} md={5}>
          <Row>
            <Col xs={4} md={12}>
              <Card.Img
                src={data.avatar ? "/backend/" + data.avatar : "./assets/img/user.jpg"}
                style={{
                  maxWidth: "200px",
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
                loading="lazy"
              />
            </Col>
            <Col xs={8} md={12} className="d-md-none">
              <Card.Title>
                <b>
                  {data.name} {data.surname}
                </b>
              </Card.Title>
              <p>{data.position}</p>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={7}>
          <div className="text-end d-none d-md-block">
            <Card.Title>
              <b>
                {data.name} {data.surname}
              </b>
            </Card.Title>
            <p>{data.position}</p>
          </div>
          <div>
            <p>
              <b>Przypisane urządzenia:</b>
            </p>
            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
              {data.currentDevices.map((device, index) => (
                <li key={index}>{device.name}</li>
              ))}
            </ul>
          </div>
          <div className="text-end">
            <Button variant="primary" onClick={() => navigate(`/user/${data.id}`)}>
              Zobacz profil
            </Button>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(UserCard);
